import { apiClient } from './client';

export interface ProjectLocationLink {
  id: number;
  location_id: number;
  name: string;
  level: 'country' | 'state' | 'lga' | 'ward' | 'community';
  parent_id: number | null;
}

export interface LocationSearchResult {
  id: number;
  name: string;
  level: 'country' | 'state' | 'lga' | 'ward' | 'community';
  parent_id: number | null;
}

export const projectLocationsApi = {
  list: (projectId: number) => apiClient.get<{ data: ProjectLocationLink[] }>(`/api/projects/${projectId}/locations`),
  add: (projectId: number, locationId: number) => apiClient.post<{ data: unknown }>(`/api/projects/${projectId}/locations`, { locationId }),
  remove: (projectId: number, locationId: number) => apiClient.delete<{ data: unknown }>(`/api/projects/${projectId}/locations/${locationId}`),
  search: (query: string) => apiClient.get<{ data: LocationSearchResult[] }>(`/api/projects/locations/search?q=${encodeURIComponent(query)}`),
  states: () => apiClient.get<{ data: LocationSearchResult[] }>('/api/projects/locations/states'),
  lgasForState: (stateId: number) => apiClient.get<{ data: LocationSearchResult[] }>(`/api/projects/locations/states/${stateId}/lgas`),
};
